
export default function routes($stateProvider) {

	$stateProvider
		.state('emailTemplateFormPage', angular.extend({
			url: '/email-templates/:id',
			resolve: {
		        loggedIn: ['User', function (User) {
		        	return User.requireLogin();
		        }],
		        emailTemplate: ['EmailTemplate', '$stateParams', function (EmailTemplate, $stateParams) {
		        	return EmailTemplate.get($stateParams.id);
		        }],
			}
		}, {
    		template: require('./emailTemplateForm.html'),
    		controller: 'EmailTemplateFormController',
    		controllerAs: 'emailTemplateForm'
    	}));

}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/emailTemplateForm/emailTemplateForm.routes.js